import React, { useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Box, Indicator, Loader, Text, Title } from "@mantine/core";
import useStyles from "./style";
import { getSingleNote } from "../../services/note";
import SignatureRequestModal from "../SignatureModal";
import { updateChangeSignature } from "../../services/signature";
import { useSelector } from "react-redux";
import swal from "sweetalert";

const NewNotificationCardComp = ({
  notification,
  handleReadNotification,
  isLoading,
  isReadAll,
  profile,
  onClickNotification,
  onOpenSignatureModal,
  setPopoverOpened,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  // const [signatureModalOpened, setSignatureModalOpened] = useState(false);
  const { signature } = useSelector((state) => state?.signature);

  const handleClick = async () => {
    if (notification?.module === "document") {
      const id =
        notification?.facility?.id ||
        notification?.staff?.id ||
        notification?.client?.id;
      if (id) {
        navigate(`/home/facility/${id}/view`, {
          state: { notificationDoc: notification },
        });
      }
    }

    if (notification?.module === "billing_authorization") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.billing
      ) {
        navigate("/home/billing-claim-form", {
          state: {
            manage: "client",
          },
        });
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Billing.",
          dangerMode: true,
        });
      }
    }

    if (notification?.module === "Invoice") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.invoice
      ) {
        navigate("/home/invoices");
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Invoice.",
          dangerMode: true,
        });
      }
    }

    if (notification && notification?.module === "document") {
      if (notification?.facility?.id) {
        navigate(`/home/facility/${notification?.facility?.id}/view`, {
          state: {
            notificationDoc: notification,
          },
        });
      } else if (notification?.staff) {
        navigate(`/home/staff/${notification?.staff?.id}/view`, {
          state: {
            notificationDoc: notification,
          },
        });
      } else if (notification?.client) {
        navigate(`/home/client`, {
          state: {
            notificationDoc: notification,
            //  client: notification?.client,
          },
        });
      }
    }
    if (notification && notification?.module === "patient") {
      if (signature === null || !signature) {
        swal({
          title: "Signature Required",
          text: "Please add a signature from setting page to continue",
          dangerMode: true,
          icon: "warning",
          buttons: {
            cancel: {
              text: "Cancel",
              visible: true,
              className: classes.cancelBtn,
            },
            confirm: {
              text: "Setup Signature",
              value: true,
              className: classes.setupBtn,
            },
          },
        }).then((value) => {
          if (value) {
            navigate("/home/settings", {
              state: { selectedTab: "my-signature" },
            });
          }
        });
      } else {
        navigate(`/home/client`, {
          state: {
            client: notification,
          },
        });
      }
    }

    if (notification && notification?.module === "signature") {
      if (notification?.userType === "staff") {
        navigate(`/home/settings`, { state: { selectedTab: "my-signature" } });
      } else {
        // setSignatureModalOpened(true);
        onOpenSignatureModal(notification);
      }
    }

    if (notification && notification?.module === "Care Plan") {
      navigate(`/home/client`, {
        state: {
          planDoc: notification,
          //  client: notification?.client,
        },
      });
    }

    if (notification && notification?.module === "Medication") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.medication
      ) {
        navigate(`/home/medication`, {
          state: {
            medication: notification,
          },
        });
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Medication.",
          dangerMode: true,
        });
      }
    }

    if (!notification?.readedUsers?.includes(profile?.user?.id)) {
      handleReadNotification(notification?._id);
    }
    if (notification?.module === "Note") {
      if (
        (!profile?.user?.role && !profile?.user?.type) ||
        !profile?.user?.permissions ||
        profile?.user?.permissions?.note
      ) {
        onClickNotification(notification?.moduleId);
        await getSingleNote(notification?.moduleId);
      } else {
        swal({
          icon: "error",
          title: "You don't have permission to access Note.",
          dangerMode: true,
        });
      }
    }
    if (notification?.module === "SkaiToken") {
      navigate("/home/settings", { state: { selectedTab: "skai-credits" } });
    }
    if (notification && notification?.module === "Timesheet") {
      navigate(`/home/staff/manage-attendance/${notification?.staff?.id}`);
    }
  };

  const getUserType = Object.keys(notification?.metadata?.file || {}).includes(
    "staff"
  )
    ? "staff"
    : Object.keys(notification?.metadata?.file || {}).includes("client")
    ? "client"
    : "facility";

  const handleAcceptSignature = async () => {
    const payload = {
      signatureId: notification?.moduleId,
      staffId: notification?.staff?.id,
    };
    await updateChangeSignature(payload);
    // setSignatureModalOpened(false);
  };

  return (
    <>
      <Box
        onClick={handleClick}
        key={notification?._id}
        className={classes.card}
      >
        {isLoading?.includes(notification?._id) ? (
          <Loader color="yellow" size={25} className={classes.loaderStyling} />
        ) : (
          <>
            <Box className={classes.titleIndicator}>
              {!notification?.readedUsers?.includes(profile?.user?.id) ? (
                <Indicator color={isReadAll ? "#737373" : "#F78C09"} />
              ) : (
                ""
              )}
              <Title order={3}>{notification?.title}</Title>
            </Box>
            {notification?.module === "document" ? (
              <Text size="sm" color="#737373" fw={400} ff="Inter">
                {`${
                  getUserType.charAt(0).toUpperCase() + getUserType.slice(1)
                } file ${notification?.metadata?.file?.name} ${
                  moment(notification?.metadata?.file?.expiry).isAfter(moment())
                    ? "expires"
                    : "has expired"
                } on (${moment(notification?.metadata?.file?.expiry).format(
                  "MM/DD/YYYY"
                )})`}
              </Text>
            ) : (
              <Text size="sm" color={"#737373"} fw={400} ff={"Inter"}>
                {notification?.message}
              </Text>
            )}

            <Text size="sm" color={"#737373"} fw={400} ff={"Inter"}>
              {moment(notification?.createdAt)?.fromNow()}
            </Text>
          </>
        )}
      </Box>

      {/* Signature Request Modal
      <SignatureRequestModal
        opened={signatureModalOpened}
        onClose={() => setSignatureModalOpened(false)}
        onAccept={handleAcceptSignature}
        notification={notification}
      /> */}
    </>
  );
};

export default NewNotificationCardComp;
